import React from 'react';
import { Card, List, Button, Space, Tag, Alert } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const Mobile = ({ viewModel }) => {
    const { list, setting, settingLoaded, onAdd, onEdit, onDelete, navigate, MODE_LABELS, APPLY_LABELS } = viewModel;

    return (
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            {settingLoaded && !setting.enabled && (
                <Alert
                    message="Tính năng bảng giá chưa bật"
                    type="warning"
                    showIcon
                    action={<Button size="small" onClick={() => navigate('/setting/pricing-tables')}>Cài đặt</Button>}
                />
            )}
            <Card
                size="small"
                title="Bảng giá"
                extra={<Button size="small" type="primary" icon={<PlusOutlined />} onClick={onAdd}>Thêm</Button>}
            >
                <List
                    dataSource={list}
                    rowKey="id"
                    renderItem={(row) => (
                        <List.Item
                            actions={[
                                <Button size="small" onClick={() => onEdit(row.id)}>Sửa</Button>,
                                <Button size="small" danger onClick={() => onDelete(row.id)}>Xoá</Button>,
                            ]}
                        >
                            <List.Item.Meta
                                title={row.name}
                                description={
                                    <Space>
                                        <Tag>{MODE_LABELS[row.mode] ?? row.mode}</Tag>
                                        <span>{APPLY_LABELS[row.apply_to] ?? row.apply_to}</span>
                                    </Space>
                                }
                            />
                        </List.Item>
                    )}
                />
            </Card>
        </Space>
    );
};

export default Mobile;
